import { useMemo } from 'react';
import { MODEL_PROVIDER_ORDER } from '@reflex/shared';
import type { ModelProviderSecret, PersistableModelProvider } from '@reflex/shared';
import { useFeatureFlag } from './useFeatureFlag';

/**
 * The model providers a key-management surface should render, honoring
 * feature-flag gating. Nebius is gated behind `nebius_provider_enabled`;
 * a provider with existing keys stays visible while the flag is off so
 * stored keys can still be rotated or removed (the server rejects only
 * *new* Nebius keys — see `rejectFlagGatedProvider` in
 * `model-provider-secret.routes.ts`).
 */
export function useVisibleModelProviders(
  secrets: readonly Pick<ModelProviderSecret, 'provider'>[] = [],
): readonly PersistableModelProvider[] {
  const nebiusEnabled = useFeatureFlag('nebius_provider_enabled');
  return useMemo(() => {
    if (nebiusEnabled) return MODEL_PROVIDER_ORDER;
    const configured = new Set(secrets.map((s) => s.provider));
    return MODEL_PROVIDER_ORDER.filter((p) => p !== 'nebius' || configured.has('nebius'));
  }, [nebiusEnabled, secrets]);
}
